/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import {
  Alert,
  CircularProgress,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useTenantTranslation } from "hooks/formatters";
import {
  useListScrapEyeDevicesQuery,
  useRenameScrapEyeDeviceMutation,
} from "src/store/api/generatedApi";
import { ScrapEyeDataDashboardDevice } from "./device/ScrapEyeDataDashboardDevice";

interface Props {
  tenantName: string;
  deviceId: number;
}

export default function DeviceInfo({ tenantName, deviceId }: Props) {
  const { t } = useTenantTranslation();
  const [renameDevice, { isLoading: renameLoading }] =
    useRenameScrapEyeDeviceMutation();
  const { data, isLoading, isError, refetch, isFetching } =
    useListScrapEyeDevicesQuery({
      tenantName,
    });
  const device = data?.items.find((device) => device.id === deviceId);

  if (isLoading) return <CircularProgress size={20} />;
  if (isError || !data)
    return <Alert severity="error">{t("errorLoadingDeviceInfo")}</Alert>;

  if (!device) return null;

  return (
    <Stack p={2}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography variant="h6" sx={{ mb: 1 }}>
          {t("deviceInfo")}
        </Typography>
        <IconButton onClick={() => void refetch()}>
          <RefreshIcon fontSize="small" />
        </IconButton>
      </Stack>
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography fontWeight={600} variant="h6">
          {device.name ?? t("deviceLabelWithHash", { id: device.id })}
        </Typography>
        <IconButton
          onClick={() => {
            const name = window.prompt(t("renameDevice"));
            if (name) {
              void renameDevice({
                tenantName,
                deviceId,
                renameScrapEyeDeviceRequest: { name: name },
              });
            }
          }}
          loading={renameLoading}
        >
          <EditIcon fontSize="small" />
        </IconButton>
      </Stack>

      <ScrapEyeDataDashboardDevice
        device={device}
        isFetching={isFetching}
        isOnlineExpected={device.installation_location != null}
      />
    </Stack>
  );
}
